module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"zip":"Zip","city":"City","street":"Street","number":"Street number","address suffix":"Address suffix"},"de":{"zip":"PLZ","city":"Ort","street":"Strasse","number":"Hausnummer","address suffix":"Adresszusatz"}}')
  delete Component.options._Ctor
}
